import { render, staticRenderFns } from "./add_pay_group.vue?vue&type=template&id=4c1d48e0"
import script from "./add_pay_group.vue?vue&type=script&lang=js"
export * from "./add_pay_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports